var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftTenetBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 553,
    viewBox: "0 0 156 553",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M541.35 288.483C541.35 427.996 428.282 541.08 288.823 541.08C149.364 541.08 36.2959 427.996 36.2959 288.483C36.2959 148.969 149.364 35.8851 288.823 35.8851C428.282 35.8851 541.35 148.969 541.35 288.483Z",
    stroke: "#F5F5F5",
    strokeWidth: 70.6913
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftTenetBg);
export default __webpack_public_path__ + "static/media/left-tenet-bg.ee006f351a90b247e2f02fe9295b2d07.svg";
export { ForwardRef as ReactComponent };